export default __webpack_public_path__ + "static/media/image-gallery-sugar-cubes.fefc3841.jpg";